// Known-noise browser errors, shared by the Sentry client (`ignoreErrors`) and
// the PostHog client (`before_send` on `$exception`) so both sinks drop the
// same events. Evidence: prod Sentry/PostHog sweep 2026-09-16 — every pattern
// here comes from browser extensions, ad blockers or browser quirks, never
// from application code. Keep real failures (e.g. `ClerkJS: Network error`,
// sign-in API errors) OUT of this list.
export const NOISE_PATTERNS: RegExp[] = [
	// Benign browser notification, spec says it can be ignored.
	/ResizeObserver loop (limit exceeded|completed with undelivered notifications)/,
	// Microsoft Edge / Outlook SafeLinks injected script.
	/Object Not Found Matching Id:\d+, MethodName:/,
	// Opaque cross-origin error with no stack (extensions, third-party tags).
	/^Script error\.?$/,
	// Clerk bundle blocked by an ad blocker / privacy extension.
	/Clerk: Failed to load Clerk, failed to load script/,
	/Loading chunk \d+ failed[\s\S]*clerk\.stytrix\.com/,
	// Clerk bot-protection widget blocked by extension or unsupported browser.
	/The CAPTCHA failed to load\. This may be due to an unsupported browser/,
	// iOS Safari's TypeError for a fetch the network dropped mid-flight (the
	// PostHog beacons in the same second fail too). STYTRIX-WEB-3M: a
	// generation on an iPhone that lost connectivity; nothing server-side.
	/^(?:Generation Failed: )?Load failed$/,
];

export function isNoiseError(message: unknown): boolean {
	if (typeof message !== 'string' || !message) return false;
	return NOISE_PATTERNS.some((re) => re.test(message));
}
